import React, { useEffect, useState } from "react"
import { Row, Col, Carousel } from "antd"

import AppFeaturedPhoto from "../../assets/images/app-featured-section.jpg"

import "./FeaturedContents.scss"
import { HomePageI } from "../../interface"
import Markdown from "markdown-to-jsx"

const homePageDatas = ({ data }) => {
  const [homePageData, sethomePageData] = useState<HomePageI>()

  useEffect(() => {
    if (data?.tarsiergraphql?.getHomepageDetails) {
      sethomePageData(data.tarsiergraphql.getHomepageDetails)
    }
  }, [data])

  const [title, setTitle] = useState("")
  const [subheader, setSubheader] = useState("")
  const [description, setDescription] = useState("")

  useEffect(() => {
    const sanitizeContent = async () => {
      if (typeof window === "undefined") return

      const mod = await import("dompurify")
      const createDOMPurify = mod.default || mod
      const DOMPurify = createDOMPurify(window)

      setTitle(DOMPurify.sanitize(homePageData?.content_title ?? ""))
      setSubheader(DOMPurify.sanitize(homePageData?.content_sub_header ?? ""))
      setDescription(
        DOMPurify.sanitize(homePageData?.content_description ?? "")
      )
    }

    sanitizeContent()
  }, [homePageData])

  return (
    <div className="featured-content-container">
      <Row className="paddingpX50">
        <Col xl={12} xs={23} className="image-featured">
          <Carousel
            autoplay
            autoplaySpeed={5000}
            className="image-featured-carousel carousel-dots-custom"
          >
            {homePageData?.content_image.includes(".mp4") ? (
              <video
                src={homePageData?.content_image}
                controls
                className="img-responsive"
              />
            ) : (
              <img
                src={homePageData?.content_image}
                className="img-responsive"
                alt="Image Feature"
              />
            )}
          </Carousel>
        </Col>
        <Col xl={12} xs={21} className="featured-content-details">
          <div>
            <Markdown
              options={{
                overrides: {
                  p: {
                    component: "h2",
                    props: { className: "title-border" },
                  },
                  span: {
                    component: "span",
                    props: { className: "title-span" },
                  },
                },
              }}
            >
              {title}
            </Markdown>
            <div className="description">
              <Markdown>{subheader}</Markdown>
              <Markdown>{description}</Markdown>
            </div>
            <a
              href={homePageData?.content_button_link}
              target="_blank"
              className="rhr-button"
            >
              {homePageData?.content_button_label}
            </a>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default homePageDatas
